import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './index.css';
import './crm.css';

// Polyfill CanvasRenderingContext2D.roundRect for iOS < 16.4 / older Safari.
if (typeof window !== 'undefined' && window.CanvasRenderingContext2D && !CanvasRenderingContext2D.prototype.roundRect) {
  CanvasRenderingContext2D.prototype.roundRect = function (x, y, w, h, r) {
    if (typeof r === 'number') r = [r, r, r, r];
    else if (Array.isArray(r)) {
      if (r.length === 1) r = [r[0], r[0], r[0], r[0]];
      else if (r.length === 2) r = [r[0], r[1], r[0], r[1]];
      else if (r.length === 3) r = [r[0], r[1], r[2], r[1]];
    } else r = [0, 0, 0, 0];
    const [tl, tr, br, bl] = r.map(v => Math.min(v, Math.abs(w) / 2, Math.abs(h) / 2));
    this.moveTo(x + tl, y);
    this.lineTo(x + w - tr, y);
    this.quadraticCurveTo(x + w, y, x + w, y + tr);
    this.lineTo(x + w, y + h - br);
    this.quadraticCurveTo(x + w, y + h, x + w - br, y + h);
    this.lineTo(x + bl, y + h);
    this.quadraticCurveTo(x, y + h, x, y + h - bl);
    this.lineTo(x, y + tl);
    this.quadraticCurveTo(x, y, x + tl, y);
    return this;
  };
}

// Global error reporter — if the app fails to boot on mobile, at least show something.
window.addEventListener('error', (e) => {
  try {
    const msg = (e?.error?.stack) || (e?.message) || String(e);
    const el = document.getElementById('boot-error') || (() => {
      const d = document.createElement('pre');
      d.id = 'boot-error';
      d.style.cssText = 'position:fixed;inset:0;background:#0d1829;color:#ff9c9c;padding:16px;font:12px/1.4 monospace;white-space:pre-wrap;z-index:99999;overflow:auto';
      document.body.appendChild(d);
      return d;
    })();
    el.textContent = 'Error:\n' + msg;
  } catch (_) {}
});
window.addEventListener('unhandledrejection', (e) => {
  window.dispatchEvent(new ErrorEvent('error', { message: 'Unhandled: ' + (e.reason?.stack || e.reason) }));
});

// Service worker para PWA (instalable + offline). Auto-update.
// Si hay nueva versión, se descarga en background y aplica en próxima carga.
import { registerSW } from 'virtual:pwa-register';
if ('serviceWorker' in navigator) {
  const updateSW = registerSW({
    immediate: true,
    onNeedRefresh() {
      console.log('[PWA] Nueva versión disponible, se aplicará en próxima carga');
    },
    onOfflineReady() {
      console.log('[PWA] App lista para uso offline');
    },
    onRegisterError(err) {
      console.warn('[PWA] Service worker registration failed:', err);
    },
  });
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode><App /></React.StrictMode>
);
